<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <span v-if="asslicenca.descricao != null">
                    <h1 class="title">{{ $t('vincular-licenca') }}: {{ asslicenca.descricao }}</h1>
                </span>
                <span v-else>
                    <h1 class="title">{{ $t('vincular-licenca') }}: {{ selected.descricao }}</h1>
                </span>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t('cancelar') }}
                </button>
                <button class="save-btn" type="button" @click="save">
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>

        <div class="columns form-columns-fit is-flex-wrap">
            <div class="columns calendar">
                <div class="column is-6">
                    <v-input
                        :id="generateId(1)"
                        ref="numeroInput"
                        title="numero"
                        placeholder="placeholder-preencha"
                        :msg="'msg-campo-obrigatorio'"
                        :required="true"
                        v-model="asslicenca.numero"
                        :invalid="isNull(asslicenca.numero)"
                        :maxlength="100"
                        tooltipLabel="informacao-licenca-numero"
                        tooltipSize="is-small"
                    />
                </div>
                <div class="column is-6">
                    <verified-date-picker
                        :id="generateId(2)"
                        ref="vencimentoInput"
                        v-model="date"
                        placeholder="selecione-uma-data"
                        title="vencimento"
                        msg="msg-campo-obrigatorio"
                        :required="true"
                        :subtractDateByDate="$moment().toDate()"
                        :addDateYears="2"
                        :years-range="[-3, 3]"
                        :invalid="isNull(date)"
                        :inForm="true"
                        tooltipLabel="informacao-licenca-vencimento"
                        tooltipSize="is-small"
                        :showClean="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssLicencaCliente from '@/services/vendas/cliente/abas/AssClienteLicencaService';
import LicencaValidation from '@/services/validations/vendas/cliente/LicencaValidation';
import Message from '@/models/Message';

export default {

    props: {
        selected: {
            type: Object,
            default: () => {},
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new AssLicencaCliente(this.$http, this.$router),
            validation: new LicencaValidation(this.msgs),
            isLoading: false,
            msgs: [],
            asslicenca: {
                idassclientelicenca: null,
                idlicenca: null,
                idcliente: null,
                numero: null,
                vencimento: null,
                descricao: null,
            },
            date: null,

            isVenda: this.$route.meta.contexto == 'vendas',
        };
    },
    created() {
        this.asslicenca.idassclientelicenca = this.selected.idassclientelicenca;
        this.asslicenca.idcliente = this.selected.idcliente;
        this.asslicenca.idlicenca = this.selected.idlicenca;
        this.asslicenca.descricao = this.selected.descricao;
        this.asslicenca.numero = this.selected.numero;
        this.asslicenca.vencimento = this.selected.vencimento;
        if (this.selected.idassclientelicenca != null) {
            this.carregarDados(this.selected.idassclientelicenca);
        }
    },
    methods: {
        carregarDados(id) {
            this.isLoading = true;

            this.find(id)
                .then((value) => {
                    this.asslicenca = value.content;
                    if (this.asslicenca.vencimento != null) {
                        this.date = this.$moment(this.asslicenca.vencimento).toDate();
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        find(id) {
            if (this.isVenda) return this.service.findVendas(id);
            else return this.service.findAgro(id);
        },

        generateId(numberId) {
            return this.$route.name + '-asslicenca-' + numberId;
        },
        save() {
            this.isLoading = true;

            let licencaTemp = Object.assign({}, this.asslicenca);
            licencaTemp.vencimento =
                this.date != null ? this.$moment(this.date).format('YYYY-MM-DD') : null;

            if (this.validation.validate(licencaTemp, this.$refs)) {
                licencaTemp = this.mapTosave(licencaTemp, 'vencimento');

                this.isSaving = true;
                this.saveLicenca(licencaTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg =
                                this.asslicenca.idassclientelicenca != null
                                    ? 'msg-edit-cliente-licenca'
                                    : 'msg-save-cliente-licenca';
                            this.msgs.push(new Message('success', msg, true));
                            this.$emit('isChanged', false);
                            setTimeout(() => {
                                this.$emit('fecharModal', true);
                            }, 1500);
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body.status == 409) {
                            this.msgs.push(new Message('alert', 'msg-existe-codigo-cliente', true));
                        } else {
                            console.error('Erro ao salvar: ' + e);
                            this.msgs.push(new Message('error', 'msg-erro-salvar', true));
                        }
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        saveLicenca(licenca) {
            if (this.isVenda) return this.service.saveVendas(licenca);
            else return this.service.saveAgro(licenca);
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 30px 30px;

    @media (max-width: 1500px) {
        #main {
            margin-bottom: 250px;
        }
    }
}
</style>
